import { useEffect, useState } from 'react'
import { useAppSelector } from './redux'
import {  REACT_APP_BSO_USER_ID, USER_ID_KEY } from '../urls'
import { type RootState } from '../store/store'

export type UserType = 'Landlord' | 'Agent' | 'Unknown' | 'AdminBSO'

interface IUserType {
    userType: UserType
    userTypeLowercase: string
    basicUserType: string
}

/**
 * Use ONLY in react components!!!
 * Outside of components use getUserType function declared in /src/functions/shared/user/getUserType.ts
 */
const UseUserType = (): IUserType => {
    const  userCATEGORY = useAppSelector((state) => state.auth).userCATEGORY
    const lsUserId = window.localStorage.getItem(USER_ID_KEY)
    const currentUser = useAppSelector((state: RootState) => state.user.currentUser)
    const userID = currentUser.id ?? lsUserId
    const [type, setType] = useState<UserType>(userCATEGORY === 'Agent' ? 'Agent' : 'Landlord')
    const [basicUserType, setBasicUserType] = useState<UserType>(userCATEGORY === 'Agent' ? 'Agent' : 'Landlord')
    useEffect(() => {
        if (userCATEGORY === 'Landlord') {
            if(Number(userID) ===  Number(REACT_APP_BSO_USER_ID) ){
                setBasicUserType('AdminBSO')
            } else {
                setBasicUserType('Landlord')
            }
            setType('Landlord')
        } else {
            setType('Agent')
        }
    }, [userCATEGORY])
    return {
        userType: type,
        userTypeLowercase: type.toLowerCase(),
        basicUserType
    }
}

export default UseUserType
